import React, {Component, Fragment} from 'react';
import PropTypes from 'prop-types';
import NotificationSystem from 'react-notification-system';
import StepZilla from "react-stepzilla";
import {BeatLoader} from 'react-spinners';
import moment from 'moment';
import {_addNotification,_addNotificationError,convertTwoDecimalPoint, 
    getLoginParent, isRegularLunchOrderType, getNotWorkingDays, getMurchantPayChargesStatus} from '../../../server/util';
import {currency_symbol, date_format} from '../../../server/constants';
import {getPackageList, getStudentsPackageDetails, saveStudentsPackageDetails, saveAuthorizedPersons} from './bcacServices'
import RegisterStudent from './RegisterStudent';
import AuthorizePersons from './authorizePersons';
import BcacPackage from './bcacPackage';
import PreviewDetails from './previewDetails';
import { groupBy } from 'lodash';
import { data } from 'jquery';
const packageTypeOptions={'Enrollment':'Enrollment','Package':'Package'};
const authorisedPerson={authorizedId:0, firstName:'',lastName:'',phoneNo:'',relation:'', isActive:true};
const packageObject={packageId:'',packageName:'', startDt:'', endDt:'', price:0, frequency:'', freqText:''};
const parentId=sessionStorage.getItem('loggedInUserInfo');
let murchantPayChargeStatus=false;
class Bcac  extends Component {
    constructor(props){
        super(props);
        this.state={
            schoolObject:{},
            packageList:[],
            paymentType:'',
            existingPackages:{},
            studentsMainObj:{},
            loading:false,
            initStep:0,
            studentPackageDetails:{}
        }
    }
    componentWillMount=()=>{
        this.initStudentPackageObject();        
    }
    componentDidMount=()=>{
        const {schoolObject}=this.state;
        this._notificationSystem = this.refs.notificationSystem;
        const schoolYear=(((schoolObject||{}).schoolObject||{}).sessionYear||{}).schoolYearValue
        this.getPackages(schoolObject.sid,schoolYear,moment().format('YYYY-MM-DD'));
    }
    initStudentPackageObject=()=>{
        const {state}=this.props.location;
        const students=(((state||{}).schoolObject||{}).students||{});
        const _initStep=((state||{}).pkgRegStudents||[]).length>0?2:0;
        const studentsObj={};
        Object.keys(students).map(keyName=>{
            (students[keyName]||[]).map(st=>{
                let sid = parseInt(convertTwoDecimalPoint(st.id,2));
                studentsObj[sid]={
                    id:sid,
                    firstName: st.firstName,
                    lastName:st.lastName,
                    isRegistered:(state.pkgRegStudents||[]).includes(sid)?true:false,
                    isSelected:(state.pkgRegStudents||[]).includes(sid)?true:false,
                    packageList:[{...packageObject}],
                    authorisedPersons:[{...authorisedPerson}]
                };
            })
        });
        murchantPayChargeStatus=getMurchantPayChargesStatus(state.sid||0);
        this.setState({schoolObject:state, initStep:_initStep, studentsMainObj:studentsObj });
    }
    calculateTotalAmount=()=>{
        const {studentPackageDetails}=this.state;
        let totalAmt=0.00;
        Object.values(studentPackageDetails||{}).map(pack=>{
            (pack||[]).map(itm=>{
                totalAmt=totalAmt+parseFloat(convertTwoDecimalPoint(itm.amount,2));
            })            
        })
        return totalAmt;
    }
    prepareFee=(type)=>{
        const studentList=Object.values(this.state.studentsMainObj);
        const filteredPack=this.state.packageList.filter((pack)=>{
            return pack.type===type;
        });
        if(type===packageTypeOptions.Enrollment){
            const isStudentAlreadyRegister=studentList.some(item=>item.isRegistered);
            let indAmt=0;
            if(isStudentAlreadyRegister){                
                const selectedStudents=studentList.filter(stu=>{
                    return (!stu.isRegistered && stu.isSelected)
                });
                if(selectedStudents.length>0){
                return filteredPack.map((pack)=>{
                    let regAmt=0;
                    studentList.forEach(item=>{
                        if(item.isRegistered){
                            regAmt=regAmt+parseFloat(convertTwoDecimalPoint(pack.price,2));
                        }
                    });
                    const price=parseFloat(convertTwoDecimalPoint(pack.price,2));
                    const maxFeePerParent=parseFloat(convertTwoDecimalPoint(pack.maxFeePerParent,2));
                    const totAmount=(selectedStudents.length*price)
                    let _amount=0;
                    if(maxFeePerParent<=0){
                        _amount=totAmount;
                    }else if(maxFeePerParent<=regAmt){
                        _amount=0;
                    }else{
                        let fee= parseFloat(convertTwoDecimalPoint(regAmt||0,2));
                        let bal=maxFeePerParent-fee;
                        selectedStudents.forEach(s=>{
                            if(bal>_amount){
                                _amount+=parseFloat(convertTwoDecimalPoint(price));
                            }                            
                        })
                    }   
                    let _bal=0;
                    let _tamount=0                
                    return {
                        charge: pack.packageName,
                        amount:_amount,
                        regSudents:selectedStudents.map(stu=>{
                            //indAmt=indAmt+parseFloat(convertTwoDecimalPoint(stu.price,2));
                            if(maxFeePerParent<=0){
                                indAmt=stu.price;
                            }else if(maxFeePerParent<=regAmt){
                                indAmt=0;
                            }else{
                                let fee= parseFloat(convertTwoDecimalPoint(regAmt||0,2));
                                _bal=maxFeePerParent-fee;
                                if(_bal>_tamount){
                                    _tamount+=parseFloat(convertTwoDecimalPoint(price));
                                    indAmt=parseFloat(convertTwoDecimalPoint(price));
                                }else{
                                    _tamount+=0;
                                    indAmt=0;
                                }
                            }
                            return {
                                id:stu.id,
                                amount:indAmt, //((indAmt+regAmt)<maxFeePerParent?price:maxFeePerParent),
                                packageId:pack.id}
                        })
                    }
                    });
                }else{
                    return [];
                }
            }else{
                const selectedStudents=studentList.filter(stu=>{
                    return (!stu.isRegistered && stu.isSelected)
                });                
                if(selectedStudents.length>0){
                    return filteredPack.map((pack)=>{
                        const price=parseFloat(convertTwoDecimalPoint(pack.price,2));
                        const maxFeePerParent=parseFloat(convertTwoDecimalPoint(pack.maxFeePerParent,2));
                        const totAmount=price+ ((selectedStudents.length-1)*price);
                        let amt=0.00;
                        return {
                            id:0,
                            packageId:pack.id,
                            charge: pack.packageName,
                            amount:parseFloat(convertTwoDecimalPoint(maxFeePerParent<=0?totAmount:(maxFeePerParent<totAmount)?maxFeePerParent:totAmount,2)),
                            regSudents:selectedStudents.map((stu,i)=>{
                                amt=amt+price;
                                return {id:stu.id,amount: (amt<=parseFloat(convertTwoDecimalPoint(maxFeePerParent,2))?price: 0),packageId:pack.id}
                            })
                        }
                    });
                }
                else{
                    return [];
                }               
            }
        }else if(type===packageTypeOptions.Package){
            const reg_selectedStudents=studentList.filter(stu=>{
                return !(!stu.isRegistered && !stu.isSelected)
            });
            let _existingPackages=[];
            Object.values(this.state.existingPackages||{}).map(data=>{
                _existingPackages=[..._existingPackages, ...data];
            })
            const existingPackGroup=groupBy(_existingPackages,'packageId');
            let _packList=[];
            reg_selectedStudents.map(stu=>{
                const fullName=`${stu.lastName}, ${stu.firstName}`;
                const _packListGroup=groupBy(_packList,'packageId');
                stu.packageList.map(pak=>{
                    if(pak.frequency=='One Time'){
                        if(((pak.packageName||'').trim()).length>0){
                            let _price=pak.price;
                            if((existingPackGroup[pak.packageId]||[]).length>0 || (_packListGroup[pak.packageId]||[]).length>0 ){
                                const selectedPack=filteredPack.find(p=>{
                                    return p.id==pak.packageId
                                });
                                if(selectedPack){
                                    const _perDiscount= parseFloat(convertTwoDecimalPoint(selectedPack.perAdditionalStdDiscountPerc,2)) 
                                    _price=((_perDiscount<=0)?(pak.price*pak.dateList.length):((pak.price*pak.dateList.length)-(((pak.price*pak.dateList.length)*_perDiscount)/100)));
                                }
                            }else{
                                const selectedPack=filteredPack.find(p=>{
                                    return p.id==pak.packageId;
                                });
                                if(selectedPack){
                                    _price=(pak.price*pak.dateList.length);
                                }
                            }
                            _packList.push({
                                id:stu.id,
                                packageId:pak.packageId,
                                charge: `${pak.packageName}-${fullName}`,
                                freqText:'',
                                amount:parseFloat(convertTwoDecimalPoint(_price,2)),
                                oneTimeDates:pak.dateList.map(d=>{
                                    return {date:d,amount: parseFloat(convertTwoDecimalPoint((_price/pak.dateList.length),2))}
                                })
                            });
                        }
                    }else{
                    if(((pak.packageName||'').trim()).length>0){
                        let _price=pak.price;
                        if((existingPackGroup[pak.packageId]||[]).length>0 || (_packListGroup[pak.packageId]||[]).length>0 ){
                            let _selectedPack=filteredPack.find(p=>{
                                return p.id==pak.packageId
                            });
                            if(_selectedPack){
                                const isThisWeekExist= (existingPackGroup[pak.packageId]||[]).find(rec=>{
                                    const freqText=(moment(rec.startDt).format('MM/YY')+'-'+moment(rec.endDt).format('MM/YY'))
                                    return freqText===(pak.startDt.format('MM/YY')+'-'+pak.endDt.format('MM/YY'))
                                })
                                const isThisWeekExistInPackList=_packList.find(rec=>{
                                    const freqText=(moment(rec.startDt).format('MM/YY')+'-'+moment(rec.endDt).format('MM/YY'))
                                    return freqText===(pak.startDt.format('MM/YY')+'-'+pak.endDt.format('MM/YY'))
                                })
                                if(isThisWeekExist||isThisWeekExistInPackList){
                                    const _perDiscount= parseFloat(convertTwoDecimalPoint(_selectedPack.perAdditionalStdDiscountPerc,2)) 
                                    _price=((_perDiscount<=0)?pak.price:(pak.price-((pak.price*_perDiscount)/100)));
                                }
                            }
                        }
                        _packList.push({
                            id:stu.id,
                            packageId:pak.packageId,
                            startDt:pak.startDt,
                            endDt:pak.endDt,
                            freqText:(pak.startDt.format('MM/YY')+'-'+pak.endDt.format('MM/YY')),
                            charge: `${pak.packageName}-${fullName}`,
                            amount:parseFloat(convertTwoDecimalPoint(_price,2))
                        });
                    }
                }
                });
            });
            return _packList;
        }
        else{            
            const reg_selectedStudents=studentList.filter(stu=>{
                return !(!stu.isRegistered && !stu.isSelected)
            });
            let _existingPackages=[];
            Object.values(this.state.existingPackages||{}).map(data=>{
                _existingPackages=[..._existingPackages, ...data];
            })
            const existingPackGroup=groupBy(_existingPackages,'packageId');
            let _packList=[];
            reg_selectedStudents.map(stu=>{
                const fullName=`${stu.lastName}, ${stu.firstName}`;
                const _packListGroup=groupBy(_packList,'packageId');
                stu.packageList.map(pak=>{
                    if(((pak.packageName||'').trim()).length>0){
                        let _price=pak.price;
                        if((existingPackGroup[pak.packageId]||[]).length>0 || (_packListGroup[pak.packageId]||[]).length>0 ){
                            const selectedPack=filteredPack.find(p=>p.id==pak.packageId);
                            if(selectedPack){
                                const isThisWeekExist= (existingPackGroup[pak.packageId]||[]).find(rec=>{
                                    const freqText=(moment(rec.startDt).format('MM/YY')+'-'+moment(rec.endDt).format('MM/YY'))
                                    return freqText===(pak.startDt.format('MM/YY')+'-'+pak.endDt.format('MM/YY'))
                                })
                                const isThisWeekExistInPackList=_packList.find(rec=>{
                                    const freqText=(moment(rec.startDt).format('MM/YY')+'-'+moment(rec.endDt).format('MM/YY'))
                                    return freqText===(pak.startDt.format('MM/YY')+'-'+pak.endDt.format('MM/YY'))
                                })
                                if(isThisWeekExist||isThisWeekExistInPackList){
                                const _perDiscount= parseFloat(convertTwoDecimalPoint(selectedPack.perAdditionalStdDiscountPerc,2)) 
                                _price=((_perDiscount<=0)?pak.price:(pak.price-((pak.price*_perDiscount)/100)));
                                }
                            }
                        }
                        _packList.push({
                            id:stu.id,
                            packageId:pak.packageId,
                            startDt:pak.startDt,
                            endDt:pak.endDt,
                            freqText:(pak.startDt.format('MM/YY')+'-'+pak.endDt.format('MM/YY')),
                            charge: `${pak.packageName}-${fullName}`,
                            amount:parseFloat(convertTwoDecimalPoint(_price,2))
                        });
                    }
                });
            });
            return _packList;
        }
    }
    getStudentsPackageDetails=(parentId, schoolId,currentDate)=>{
        this.setState({ loading: true});
        getStudentsPackageDetails(schoolId,currentDate, parentId)
        .then((response) => {
            if (!response.ok) {
                throw Error(response.statusText);
            }
            return response.json();
        }).then(data => {
            const packObject=(data||{}).response||{};
            const authPersons=(data||{}).resp1||{};
            const _studentsMainObj=this.state.studentsMainObj;
            Object.keys(authPersons).map(key=>{
                if(_studentsMainObj[key]){
                    if(authPersons[key].length>0)
                    _studentsMainObj[key].authorisedPersons=(authPersons[key]||[]).map(p=>{
                        p.isActive=true;
                        return p;
                    });
                }
            })
            this.setState({ existingPackages:packObject,  studentsMainObj:_studentsMainObj, loading: false});
        })
        .catch(
            (error) => {
                console.log('Get orderlist response', error)
                this.setState({ existingPackages:{}, loading: false})
            
            })
    } 
    getPackages=(schoolId, schoolYear,currentDate)=>{
        this.setState({ loading: true});
        getPackageList(schoolId, schoolYear)
        .then((response) => {
            if (!response.ok) {
                throw Error(response.statusText);
            }
            return response.json();
        }).then(data => {
            const list=((data||{})._embedded||{}).schoolPackages||[];
            this.setState({ packageList:list.map(itm=>{
                itm['id']=itm._links.self.href.split('/').pop();
                return itm;
            }), loading: false},()=>{
                this.getStudentsPackageDetails(getLoginParent(),schoolId,currentDate) 
            });
        })
        .catch(
            (error) => {
                console.log('Get orderlist response', error)
                this.setState({ packageList:[], loading: false})
            }
        )
    }
    addDeleteAuthorizedPerson=(sid,index,action)=>{
        if(action==='Add'){
            const studentsObj= {...this.state.studentsMainObj};
            studentsObj[sid].authorisedPersons.push({...authorisedPerson});
            this.setState({studentsMainObj:studentsObj})
        }
        if(action==='Del'){
            const studentsObj= {...this.state.studentsMainObj};
            if(studentsObj[sid].authorisedPersons[index].authorizedId==0){
                studentsObj[sid].authorisedPersons.splice(index,1);
            }else{
                studentsObj[sid].authorisedPersons[index].isActive=false;
            }            
            this.setState({studentsMainObj:studentsObj})
        }
    }
    onChangeAuthorizedPersonValues=(sid,index,e)=>{
        const studentsObj= {...this.state.studentsMainObj};
        studentsObj[sid].authorisedPersons[index][e.target.name]=e.target.value
        this.setState({studentsMainObj:studentsObj});
    }
    onPackageSelected=(sid,pkgObj,index,e)=>{
        const studentsObj= {...this.state.studentsMainObj};
        const studentPackageDetails={...this.state.studentPackageDetails};
        const selectedObj=studentsObj[sid].packageList[index];
        if(pkgObj){
            let currentDate=moment();
            const _existingPackages=this.state.existingPackages;
            const selectedStudentPack=_existingPackages[sid];
            let selectedPack=undefined;
            if((selectedStudentPack||[]).length>0){
                selectedPack=selectedStudentPack.filter(p=>{
                    return p.packageId==pkgObj.id;
                });
            }
            if(((selectedPack||[]).length>0)){
                const idx=selectedPack.length-1;
                currentDate=(moment(new Date(selectedPack[idx].endDt))>currentDate?moment(new Date(selectedPack[idx].endDt)):currentDate);
            }            
            if(pkgObj.frequency=='Monthly'){
                selectedObj.packageId=pkgObj.id;
                selectedObj.packageName=pkgObj.packageName;
                selectedObj.startDt=moment(currentDate).add(1, 'months').startOf('M');
                selectedObj.endDt=moment(currentDate).add(1, 'months').endOf('M');
                selectedObj.price=pkgObj.price;
                selectedObj.frequency= pkgObj.frequency;
                selectedObj.freqText= moment(currentDate).add(1, 'months').format('MMM-YY');
            }
            else if(pkgObj.frequency=='Weekly'){
                selectedObj.packageId=pkgObj.id;
                selectedObj.packageName=pkgObj.packageName;
                selectedObj.startDt=moment(currentDate).add(1, 'weeks').startOf('W');
                selectedObj.endDt=moment(currentDate).add(1, 'weeks').endOf('W');
                selectedObj.price=pkgObj.price;
                selectedObj.frequency= pkgObj.frequency;
                selectedObj.freqText= `${moment(selectedObj.startDt).format('MM/DD')}-${moment(selectedObj.endDt).format('MM/DD')}`;
            }else if(pkgObj.frequency=='One Time'){
                const _selectedPack= (groupBy(this.state.existingPackages[sid]||[],'frequency')||{})[pkgObj.frequency]||[];
                selectedObj.packageId=pkgObj.id;
                selectedObj.packageName=pkgObj.packageName;
                selectedObj.startDt=undefined
                selectedObj.endDt=undefined
                selectedObj.price=pkgObj.price;
                selectedObj.frequency= pkgObj.frequency;
                selectedObj.dateList=[];
                selectedObj.previousBookedDates=_selectedPack.map(item=>{
                    return moment(item.startDt).toDate();
                })
            }else{
                selectedObj.packageId=pkgObj.id;
                selectedObj.packageName=pkgObj.packageName;
                selectedObj.startDt=undefined
                selectedObj.endDt=undefined
                selectedObj.price=pkgObj.price;
                selectedObj.frequency= pkgObj.frequency;
                selectedObj.freqText= `No Frequency`;
            }
        }else{
            const cpack=studentsObj[sid].packageList[index];
            studentsObj[sid].packageList[index]={...packageObject};
            const idx=(studentPackageDetails[sid]||[]).findIndex(sp=>{
                return sp.packageId==cpack.packageId;
            });
            if(idx>-1){
                studentPackageDetails[sid].splice(idx,1);
            }
        }
        this.setState({studentsMainObj:studentsObj,studentPackageDetails:studentPackageDetails},()=>{
            /*  if(((pkgObj||{}).frequency)=='One Time'){
                return false;
            } */
            const regList=this.prepareFee(packageTypeOptions.Package);
            const {studentPackageDetails}=this.state;
            regList.map(s=>{
                studentPackageDetails[s.id]=[s];
            })            
            this.setState({studentPackageDetails:studentPackageDetails})
        });
    }
    saveAuthorizedPersons=(list=[])=>{
        if(list.length>0){
            this.setState({ loading: true});
            saveAuthorizedPersons(list).then((response) => {
                if (response.status === 200) {                 
                  _addNotification('Authorized persons details saved successfully.', this);
                } else if (!response.ok) {
                  _addNotificationError('Failed to save authorized persons details! Try again.', this);
                    throw Error(response);
                }
                this.setState({ loading: false});
            }).catch(
                (error) => {        
                  this.setState({ loading: false});        
                  console.log('save authorized persons:',error);
                }
            );
        }
    }
    onToken=(data)=>{
        this.setState({ loading: true}); 
        console.log(data);
         saveStudentsPackageDetails(data).then((response) => {
          if (response.status === 200) {                 
            _addNotification('Package payment done successfully.', this);
            setTimeout(() =>
             window.location.replace('/parent')
                , 3000);
          } else if (!response.ok) {
            _addNotificationError('Failed to add package payment ! Try again.', this);
              throw Error(response);
          }
          this.setState({ loading: false});
      }).catch(
          (error) => {        
            this.setState({ loading: false});        
            console.log('Payment error:',error);
          }
      );
    }
    render() { 
        const currencySymbol=currency_symbol(this.state.schoolObject.sid);
        const steps =[
            {id:0,name:'Registration',
            component:<RegisterStudent 
            packageList={this.state.packageList} 
            students={this.state.studentsMainObj}
            schoolId={this.state.schoolObject.sid}
            currency={currencySymbol} 
            onSelectStudent={(sid,checked)=>{
               const students= this.state.studentsMainObj
               students[sid].isSelected=checked;               
               this.setState({studentsMainObj:students},()=>{
                    const regList=this.prepareFee(packageTypeOptions.Enrollment);
                    const {studentPackageDetails}=this.state;
                    studentPackageDetails[0]=regList;
                    this.setState({studentPackageDetails:studentPackageDetails})
               });
            }}
            studentPackages={this.state.studentPackageDetails} totalAmount={this.calculateTotalAmount()} />}
            ,{id:1, name:'Authorize Persons', 
            component:<AuthorizePersons 
            packageList={this.state.packageList}
            currency={currencySymbol}
            schoolId={this.state.schoolObject.sid}
            addDeleteAuthorizedPerson={this.addDeleteAuthorizedPerson} 
            onChangeAuthorizedPersonValues={this.onChangeAuthorizedPersonValues}
            students={this.state.studentsMainObj} 
            studentPackages={this.state.studentPackageDetails} 
            saveAuthorizedPersons={
                (list)=>{
                    this.saveAuthorizedPersons(list);
                }}
            totalAmount={this.calculateTotalAmount()} />}
            ,{id:2, name:'Bcac Package', 
            component:<BcacPackage {...this}
            packageList={this.state.packageList} 
            paymentType={this.state.paymentType}
            hiddenDays={getNotWorkingDays( this.state.schoolObject.sid)}
            currency={currencySymbol}
            schoolId={this.state.schoolObject.sid} 
            onPackageSelected={this.onPackageSelected}
            students={this.state.studentsMainObj} 
            onChangePaymentType={(value)=>{
                this.setState({paymentType:value})
            }}
            addDates={(sid,date)=>{
                const {studentsMainObj}=this.state;
                const dateList=(studentsMainObj[sid].packageList[0]||{}).dateList||[];
                const count=dateList.filter(d=>{
                    return d.format('YYYYMMDD')==date.format('YYYYMMDD')
                }).length;
                if(count<=0){
                    dateList.push(date);
                }                
                (studentsMainObj[sid].packageList[0]||{}).dateList=dateList;
                this.setState({studentsMainObj:studentsMainObj},()=>{
                    const regList=this.prepareFee(packageTypeOptions.Package);
                    const {studentPackageDetails}=this.state;
                    regList.map(s=>{
                        studentPackageDetails[s.id]=[s];
                    })            
                    this.setState({studentPackageDetails:studentPackageDetails})
                });
            }}
            removeDates={(sid,index)=>{
                const {studentsMainObj}=this.state;
                const dateList=(studentsMainObj[sid].packageList[0]||{}).dateList||[];
                dateList.splice(index,1);
                (studentsMainObj[sid].packageList[0]||{}).dateList=dateList;
                this.setState({studentsMainObj:studentsMainObj},()=>{
                    const regList=this.prepareFee(packageTypeOptions.Package);
                    const {studentPackageDetails}=this.state;
                    regList.map(s=>{
                        studentPackageDetails[s.id]=[s];
                    })            
                    this.setState({studentPackageDetails:studentPackageDetails})
                });
            }}

            studentPackages={this.state.studentPackageDetails} 
            totalAmount={this.calculateTotalAmount()}  />}
            ,{id:3, name:'Preview', component:<PreviewDetails packageList={this.state.packageList} 
            currency={currencySymbol}
            excludeCharges={murchantPayChargeStatus}
            paymentType={this.state.paymentType}
            schoolId={this.state.schoolObject.sid}
            students={this.state.studentsMainObj} 
            studentPackages={this.state.studentPackageDetails} 
            totalAmount={this.calculateTotalAmount()}
            onToken={this.onToken}  />}
        ];        
        return (
        <Fragment>
             <div>
                <NotificationSystem ref="notificationSystem"/>                
                    <section className=" full-width clearfix margin-top">
                        <div className='sweet-loading' style={{position: 'fixed', top: '50%', left: '48%', zIndex: '1000'}}>
                            <BeatLoader
                                size={20}
                                color={'#ea7066'}
                                loading={this.state.loading}
                            />
                        </div>
                        <div className="container">                        
                            <div className="sectionTitle" >
                                <h2 style={{textTransform: 'none'}}>
                                {<span>Before & After Care Program</span>}
                                    <button className="pull-right btn btn-xs bg-color-4" style={{margin:'0px',color:'#ffffff',marginTop:'10px'}} onClick={(e) => {
                                        e.preventDefault();
                                        let _self=this;
                                        _self.context.router.history.goBack() ;
                                    }}><i className="fa fa-arrow-circle-left" aria-hidden="true"></i> Back</button>
                                </h2>
                            </div>
                            <div className="row">
                                <div className="col-xs-12">
                                    <StepZilla steps={steps} 
                                        showNavigation={false}
                                        nextButtonCls= "btn btn-prev btn-xs bg-color-2 pull-right"
                                        backButtonCls= "btn btn-next bg-color-4 btn-xs pull-left"
                                        nextTextOnFinalActionStep= "Save"
                                        nextButtonText= "Continue"
                                        prevBtnOnLastStep={false} 
                                        startAtStep={this.state.initStep}
                                        showSteps={false}
                                    />
                                </div>
                            </div>
                        </div>
                    </section>
                </div>
        </Fragment>);
    }
}
Bcac.contextTypes = {
    router: PropTypes.object.isRequired
}
 
export default Bcac;


// WEBPACK FOOTER //
// ./src/components/Parent/bcac/index.jsx